module.exports = __webpack_public_path__ + "img/arrow-down.ad90cb12.svg";